module.exports = __webpack_public_path__ + "img/product-p1_pic@2x.a6c32d66.png";